import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { nanoid } from 'nanoid'
import { Button, EnumIconButtonShape } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { DeviceItemsEnum, DeviceSettings } from 'entities/DeviceSettings'
import { useAICallingAgentManageContext } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/context'
import { LiveKit } from 'pages/chatbot/pages/calling/ui/AICallingAgentManage/ui/TestAgent/LiveKit/LiveKit'
import styles from './styles.module.scss'

export const TestAgent = observer(() => {
  const { response, blockerStore, onSave, testAgentStore } = useAICallingAgentManageContext()
  const {
    endTest,
    isActiveAgent,
    loading,
    deviceSettingsStore,
    startTest,
    data,
    room,
    checkPermissions,
  } = testAgentStore

  const handleTest = async () => {
    if (loading) return
    if (blockerStore.isExistChanges || !response?.id) {
      const modalId = nanoid()
      modalStore.addModal({
        id: modalId,
        type: ModalTypeList.INFO,
        title: 'Save agent before testing',
        primaryAction: {
          text: 'Save & Test',
          onAction: async () => {
            const data = await onSave({
              isForTest: true,
            })
            modalStore.closeModal(modalId)
            if (data) {
              await startTest(data.id)
            }
          },
        },
        secondaryAction: {
          text: 'Cancel',
          onAction: () => {
            modalStore.closeModal(modalId)
          },
        },
      })
    } else {
      await startTest(response.id)
    }
  }

  useEffect(() => {
    return endTest
  }, [])

  return (
    <>
      {data && room && (
        <LiveKit
          data={data}
          room={room}
          deviceSettingsStore={deviceSettingsStore}
          loading={loading}
        />
      )}
      <div className={styles.wrap}>
        {isActiveAgent ? (
          <Button
            text={'End test call'}
            icon={'phoneHangUp'}
            size={'medium'}
            contained={'primary'}
            intent={'destructive'}
            iconProps={{ fontSize: 14 }}
            className={styles.leftBtn}
            onClick={endTest}
          />
        ) : (
          <Button
            text={loading ? 'Connecting' : 'Test agent'}
            icon={'phoneStar'}
            size={'medium'}
            contained={'secondary'}
            iconProps={{ fontSize: 14 }}
            className={styles.leftBtn}
            onClick={handleTest}
            loading={loading}
            disabled={loading}
          />
        )}

        <DeviceSettings
          deviceSettingsStore={deviceSettingsStore}
          dropdownProps={{
            disabled: loading,
            onChangeOpen: async (status) => {
              if (status) {
                await deviceSettingsStore.syncDevicesStream()
              } else {
                deviceSettingsStore.removeStream()
              }
            },
            placement: 'bottom-end',
            width: 246,
            margin: 8,
            ariaLabel: 'deviceSettings',
            checkIsCanOpen: checkPermissions,
          }}
          iconButtonProps={{
            disabled: loading,
            fontSize: 12,
            variant: 'contained',
            icon: 'chevronDown',
            shape: EnumIconButtonShape.None,
            className: styles.rightBtn,
            color: isActiveAgent ? 'primary' : 'secondary',
            intent: isActiveAgent ? 'destructive' : undefined,
          }}
          variantDropdownBtn={'icon'}
          exclude={[DeviceItemsEnum.recordAuto]}
        />
      </div>
    </>
  )
})
